type Props = {
  title?: string;
};

export const CopilotTitle: React.FC<Props> = ({ title }) => {
  return (
    <span className="font-inter-normal-13px text-gray-800">
      {title || "Taktile Copilot"}
    </span>
  );
};
